import React from 'react';
import PropTypes from 'prop-types';
import { Header, SideBar } from '..';

import './AppLayout.scss';

const AppLayout = ({ children })=> {
  return (
    <div className="app-layout" data-testid="app-layout">
      <Header />
      <div className="app-layout__body">
        <SideBar />
        <div className="app-layout__body__content">
          {children}
        </div>
      </div>
    </div>
  );
};

AppLayout.propTypes = {
  children: PropTypes.any, 
};

AppLayout.defaultProps = {
  children: null
};

export default AppLayout;